module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAA2CAMAAAAMJmLIAAAAZlBMVEUAAAD////MzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzOzs7MzMzMzMzPz8/MzMz////MzMze3t7j4+Pm5ubk5OTg4ODo6Oi6xG0fAAAAGnRSTlMALQS4CqCbwr2sqJCLgw4ItLDnxpVxWkx3aZmj4fwAAADESURBVDjLldVLDsIwDEXRQlr+FAq0QMKv+98kFkR6g5tEqqdnEsX2c3U9ubbKlgvhnOchFPluvKyz3Bd5Nhqv6px6cUp/7A459S8xNPJxnlQw1L+NO7FUvBZLyVT/NN5EloKh4kYsJVP9x3gBBUPJVP8wvkhTvIWCpeAdFCwF76coUUqU8k1QoBR/IQVC0QMouk+ECpsKypmTEqWYdaqQqh2DAqHabapygfpHFxGqPEroKGTdSjHZl3Ao5q8roV2Nrs3iF68ASCIsb9EJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_index_product_more.png
// module id = utkU
// module chunks = 1